import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import axios from "axios";
import {setLessonsTestAllowed} from "features/model/slice/lessons/lessons-test-allowed/lessonsTestAllowedSlice";


export const getLessonsTestsAllowed = createAsyncThunk(
    "lessons/testsAllowed",
    async (lessonsId:string | undefined, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const response = await axios.get<TestAllowedResponse>(`/api/lessons/${lessonsId}/tests-allowed`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setLessonsTestAllowed(response.data.data))
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);